import { produce } from 'immer';

import { SnapdocsSubscriptionsLoadState } from 'constants/snapdocsSubscriptions';

import { SNAPDOCS_SUBSCRIPTIONS_ACTION_TYPE } from '../actions';

const initialState = {
  requestId: null,
  loadState: SnapdocsSubscriptionsLoadState.LOADING,
  errorMessage: null,
  subscriptions: [],
  isRegistering: false,
};

const snapdocsSubscriptionsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case SNAPDOCS_SUBSCRIPTIONS_ACTION_TYPE.GET_SNAPDOCS_SUBSCRIPTIONS_REQUEST:
        draft.requestId = payload.requestId;
        draft.loadState = SnapdocsSubscriptionsLoadState.LOADING;
        draft.errorMessage = null;
        break;

      case SNAPDOCS_SUBSCRIPTIONS_ACTION_TYPE.GET_SNAPDOCS_SUBSCRIPTIONS_SUCCESS:
        if (payload.requestId !== state.requestId) {
          return state;
        }

        draft.loadState = SnapdocsSubscriptionsLoadState.LOADED;
        draft.subscriptions = payload.subscriptions;
        break;

      case SNAPDOCS_SUBSCRIPTIONS_ACTION_TYPE.GET_SNAPDOCS_SUBSCRIPTIONS_FAILURE:
        if (payload.requestId !== state.requestId) {
          return state;
        }

        draft.loadState = payload.loadState;
        draft.errorMessage = payload.errorMessage;
        draft.subscriptions = [];
        break;

      case SNAPDOCS_SUBSCRIPTIONS_ACTION_TYPE.REGISTER_SNAPDOCS_SUBSCRIPTION_REQUEST:
        draft.isRegistering = true;
        break;

      case SNAPDOCS_SUBSCRIPTIONS_ACTION_TYPE.REGISTER_SNAPDOCS_SUBSCRIPTION_SUCCESS:
      case SNAPDOCS_SUBSCRIPTIONS_ACTION_TYPE.REGISTER_SNAPDOCS_SUBSCRIPTION_FAILURE:
        draft.isRegistering = false;
        break;

      default:
        return state;
    }
  });

export default snapdocsSubscriptionsReducer;
